<template>
  <div
    id="app"
    v-cloak
  >
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  // mounted() {
  //   if (this.isMobile()) {
  //     // this.$router.push({ path: "/developing" });
  //     this.$router.push({ path: "/homes" });
  //   } else {
  //    this.$router.push({ path: "/logo" });
  //   }
  // },
  // methods: {
  //   isMobile() {
  //       let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  //       return flag;
  //   }
  // }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue